
import { mapState } from "vuex";
import { ITEM_WISE_SALES_DETAILED_PAGE_VISITED } from "@/constants/MixpanelEvents.js";
export default {
  components: {
    ReportOrdersCount: () =>
      import("@/components/report/report-orders-count.vue"),
    reportHeaderRow: () => import("@/components/report/report-header-row.vue"),
    ReportItemWiseSalesTable: () =>
      import("@/components/report/report-item-wise-sales-table.vue"),
    ReportItemSales: () => import("@/components/report/report-item-sales.vue")
  },
  data() {
    return {
      isCategoryDisplayed: false
    };
  },
  computed: {
    ...mapState("report", ["summary", "reportLoading"]),
    ...mapState("restaurant", ["locationDetails"])
  },
  mounted() {
    this.mixPanelTrackEvent(ITEM_WISE_SALES_DETAILED_PAGE_VISITED);
  },
  methods: {
    handleDisplayCategoryToggle(switchStatus) {
      this.isCategoryDisplayed = switchStatus;
    }
  }
};
